<template lang="pug">
  .stepper
    v-divider.mt-8.mb-n5
    v-layout
      div.px-3.basic100.text-center(v-for="(item, index) in filteredSteps" :key="item.title" :class="index !== 0 && index !== filteredSteps.length - 1 ? 'mx-auto' : ''")
        v-avatar(v-if="stepCompleted || index < steps.map(m => m.title).indexOf(steps[stepIndex].title)" :color='$vuetify.theme.themes[$theme].primary500' size=32 class="step-selected")
          eva-icon.mt-1(name="checkmark-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="16" height="16")
        v-avatar(v-else :color='stepIndex == index ? $vuetify.theme.themes[$theme].primaryT08 : $vuetify.theme.themes[$theme].basic600T08' size=32 :class="stepIndex == index ? 'step-selected' : 'step-normal'")
          .button-AA-small(:class="stepIndex == index ? 'textColor--text' : 'textColorHint--text'") {{ index + 1 }}
        .c2.mt-1(:class="stepIndex == index ? 'textColor--text' : 'textColorHint--text'") {{ item.title }}
</template>

<script>
export default {
  name: 'YStepper',
  model: {
    prop: 'inputValue',
    event: 'change',
  },
  props: {
    currentStep: {
      default: 0
    },
    steps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    step: {
      get() {
        return this.currentStep
      },
      set(newValue) {
        this.$emit('update:currentStep', newValue);
      }
    },
    filteredSteps () {
      return (this.steps.filter(step => !step.hidden))
    },
    stepIndex () {
      return this.filteredSteps.map(m => m.title).indexOf(this.steps[this.step].title)
    },
    stepCompleted () {
      if (this.step > this.steps.map(m => m.title).indexOf(this.filteredSteps[this.filteredSteps.length-1].title)) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
.step-selected::after {
  border: 1px solid var(--v-primary500);
  border-radius: 50%;
  bottom: 0;
  content: "";
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
}

.step-selected.avatar--tile::after {
  border-radius: 3px;
}

.step-normal::after {
  border: 1px solid var(--v-basic600);
  border-radius: 50%;
  bottom: 0;
  content: "";
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
}

.step-normal.avatar--tile::after {
  border-radius: 3px;
}
</style>
